module.exports = __webpack_public_path__ + "img/cancelled.b18df757.svg";